import React, { Component } from 'react'
import { Panel, Col, Row,  FormGroup } from "react-bootstrap"
import {  reduxForm,propTypes,formValueSelector,
          change,untouch,getFormSyncErrors } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import moment from 'moment';
import { PropTypes } from 'prop-types'
import {  fetchActiveSeasons, saveSeasonDates, triggerSeason,resetDatesSettings } from "../../../redux/actions/seasonActions"
import logo from '../../../images/PinStar-15PX.png'
import { style, warning, blue } from '../../../utils/constants'
import { isEmpty } from '../../../utils/functions'
import Location from './Location'
import InfoSaved from './InfoSaved'

const datesTab = 1
const formName = 'seasonsettings'
class TriggerSeason extends Component {
	static propTypes = {
			...propTypes
	}
	state = {
		tournamentCity: '',
		tournamentState: '-1',
		tournamentDate: null,
		locationNotSpecifiedError: false
	}
	constructor(props,context) {
		super(props,context)
		this.handleSetupSeason    = this.handleSetupSeason.bind(this)
		this.resetFields  = this.resetFields.bind(this)
		this.disableSave = this.disableSave.bind(this)
		this.onHandleLocationChange = this.onHandleLocationChange.bind(this)
	}
    componentDidUpdate(){
        
			const {  initialize,datasaved,settingsSaved } = this.props

			if (datasaved) {
				
				initialize({}, true)
				settingsSaved(true,datesTab)
			}
	
    }
    onHandleLocationChange(city,state,date) {
			this.setState({ 
				tournamentCity: city,
				tournamentState: state,
				tournamentDate: date,
				locationNotSpecifiedError: false
			})
    }
    handleValueChange(){
        const { dispatch, settingsSaved } = this.props
        dispatch(change(formName,'datasaved',false))
        settingsSaved(false,datesTab)
    }

    handleSetupSeason() {
			const { tournamentCity, tournamentState, tournamentDate } = this.state
			const { triggerSeason, dispatch } = this.props
			const seasonId =  this.props.seasonId !== undefined ? this.props.seasonId: this.state.seasonId

			const season = {
				SeasonId:seasonId
			}
			
			if ((tournamentCity === '') || (tournamentState === '-1') || (isEmpty(tournamentDate) === true))
			{
				this.setState({ locationNotSpecifiedError: true });
			}
			else {
				dispatch(change('seasondates', 'isSettingSeason',true))
				triggerSeason(seasonId,season,tournamentCity,tournamentState, moment(tournamentDate).format('MM-DD-YYYY'))
				this.setState({ locationNotSpecifiedError: false });
			}
    }

    resetFields = (formName, fieldsObj) => {
        Object.keys(fieldsObj).forEach(fieldKey => {
					this.props.dispatch(untouch(formName, fieldKey));
        })
    }

   
    disableSave() {
      return false
    }
    render() {
 
      const {  
				year,
				isSettingSeason, 
				datasaved,
				seasontriggered
			} = this.props

      const {  locationNotSpecifiedError } = this.state

       return (
				<Row className="center-block center-text">
          <form name='seasondates' className="form-horizontal" sm={12}  style={{ padding:'0',margin:'0' }} >
						<Col sm={12}>     
							<Panel>       
								<span className='col-sm-12' style={{ color:blue, marginBottom: '20px' }}>
									<i className="fa fa-info-circle" aria-hidden="true" />&nbsp;&nbsp;&nbsp;Please setup the season by specifying the JG tournament date and location.
								</span>													
								{
									locationNotSpecifiedError && (<span style={{ color: 'red', fontSize: '14px', marginLeft: '17px', marginTop: '-15px' }}><i className="fa fa-exclamation-triangle" aria-hidden="true" />&nbsp;&nbsp;&nbsp;Please specifiy JG tournament location</span>)
								}
								<FormGroup>
									<label className='col-sm-12'> 
											<img src={logo} style={{ marginLeft: '17px', maxWidth:'30px', marginTop:'-3px' }} />&nbsp;&nbsp;{ this.props.description } &nbsp;Season Year
									</label>
								</FormGroup>  
								<Location locationChange={this.onHandleLocationChange} year={year}  />                     
								<FormGroup>
									<label className={style.lblattrs8} style={{  color: warning, fontWeight: 'bold', paddingLeft: '3%', marginLeft: '-6%' }}>* Setup Season will copy all settings from the previous season.</label>
								</FormGroup>
								<FormGroup>
										<Col  lg={5}>
											<button type="button" className="btn btn-default" style={{ color: blue, fontWeight: 800, marginLeft: '15px' }} onClick={this.handleSetupSeason} >
													<i className={isSettingSeason ? 'fa fa-spinner fa-spin' : "fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Setup Season
											</button>
											{
													datasaved && (<InfoSaved section='Season dates' />)
											}
											{
													seasontriggered && (<InfoSaved custommessage='Season has been successfully triggered.' />)
											}
										</Col>
								</FormGroup>
						</Panel>
            </Col>
          </form>     
        </Row>              
        )
    }
}

TriggerSeason.propTypes = {
    handleSubmit: PropTypes.func,
    syncErrors:PropTypes.object,
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    reset:PropTypes.func,
    datasaved:PropTypes.bool,
    seasontriggered:PropTypes.bool,
    fetchActiveSeasons: PropTypes.func,
    triggerSeason:PropTypes.func,
    savingdata:PropTypes.bool,
    isSettingSeason:PropTypes.bool,
    seasonyear: PropTypes.string,
    settingsseason:PropTypes.string,
    settingsSaved: PropTypes.func,
    resetform:PropTypes.bool,
    resetDone:PropTypes.func,
    hasSeasonBeenSet:PropTypes.func,
    seasonId:PropTypes.number,
    description:PropTypes.string,
		seasonsettings: PropTypes.object,
		year: PropTypes.number,
}

function mapStateToProps(state,ownProps) {
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const seasonyear     = selector(state,'seasonyear')
    const savingdata     = selector(state,'savingdata')
    const isSettingSeason    = selector(state,'isSettingSeason')
    const datasaved    = selector(state,'datasaved')
    const seasontriggered = selector(state,'seasontriggered')
    const syncErrors = getFormSyncErrors(formName)(state)
    const datesreset    = selector(state,'datesreset')
    const seasonsettings = selector(state,'seasonsettings')
    return {
        seasonyear,
        savingdata,
        settingsseason,
        isSettingSeason,
        datasaved,
        seasontriggered,
        syncErrors,
        datesreset,
        seasonsettings,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchActiveSeasons,
        saveSeasonDates,
        triggerSeason,
        resetDatesSettings
      },dispatch)
}

function validate(values) {

    const { settingsseason,seasondates } = values

    const errors = {}
   
    if(seasondates && settingsseason) {       
        const season = seasondates[settingsseason]
        const { isSeasonSet } = season
        let errorCounter = 0

        if(!isSeasonSet) 
        {       
					errors[errorCounter++]  = "Initiate the season by specifying the JG tournament location and then clicking 'Setup season'"
        }
    }
    return errors
} 
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(TriggerSeason))




// WEBPACK FOOTER //
// ./src/containers/season/components/TriggerSeason.js